import { Spacing, Text } from '@vkontakte/vkui';
import React, { useCallback, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { productsController } from 'reactApp/modules/products/products.controller';
import { FlexibleQuotaBlock } from 'reactApp/ui/FlexibleQuotaModal/ui/Block/FlexibleQuotaBlock';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './FlexbileQuotaModal.css';

export interface FlexibleQuotaModalProps {
    source: string;
    onClose?(): void;
}

export function FlexibleQuotaModal({ source, onClose }: FlexibleQuotaModalProps) {
    useEffect(() => {
        productsController.loadProducts();
        emitAnalyticEvent(AnalyticEventNames.FLEXIBLE_QUOTA_MODAL_SHOW, { source });
        sendPaymentGa({
            action: 'show',
            eventCategory: ECategoryGa.modal,
            name: `mnz_${source}`,
        });
    }, []);

    const renderHeader = useCallback(() => <>Увеличение Облака</>, []);

    const renderContent = useCallback(
        () => (
            <div className={styles.content}>
                <Text className={styles.text}>
                    Выберите, сколько места хотите добавить. До&nbsp;1&nbsp;000&nbsp;ГБ добавляйте по&nbsp;10&nbsp;ГБ, после&nbsp;&mdash;
                    по&nbsp;100
                </Text>
                <Spacing size={60} />
                <FlexibleQuotaBlock source={source} />
            </div>
        ),
        []
    );

    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);
    return (
        <BaseConfirmDialog
            className={styles.root}
            contentClassName={styles.dialogContent}
            size="large"
            dataQAId="flexible-quota-modal"
            buttons={[]}
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={handleClose}
        />
    );
}
